





















































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class HuanzhejibenxinxiCmp extends Vue {
  @Prop()
  private projectId: any;
  @Prop()
  private patient: any;
  private groups: any[] = [];
  private hospitals: any[] = [];
  private patientChange() {
    this.$emit("update:patient", this.patient);
  }
  private get composeDisabled() {
    return this.$store.state.researchListComposeDiabled;
  }
  /**
   * @description 获取该项目下的所有分组
   */
  private fetchGroups() {
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {
          project_id: this.projectId
        }
      };
      axios
        .get("api/project/groups", params)
        .then(({ data }) => {
          resHandle(this, data).then(() => {
            this.groups = data.data;
            resolve();
          });
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 获取该项目所属的所有分中心
   */
  private fetchHospitals() {
    const params: any = {
      params: {
        project_id: this.projectId
      }
    };
    axios.get("api/project/user/hospitals", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.hospitals = data.data;
      });
    });
  }
  private beforeMount() {
    this.fetchGroups();
    this.fetchHospitals();
  }
}
